'use strict'

require('typeface-rubik')
require('typeface-lato')
